import { useMemo } from 'react'

export const useAppRunningContext = () => {
  return useMemo(() => {
    return {
      withinIframe: window.parent !== window.self,
    }
  }, [])
}
